// src/components/PrivacyPolicy.js
import React from "react";

const PrivacyPolicy = () => {
  return (
    <div style={{ padding: "40px", color: "#000", maxWidth: "800px", margin: "0 auto", background: "#fff" }}>
      <h1>Privacy Policy</h1>
      <p><strong>Last updated:</strong> July 3, 2025</p>

      <p>
        At LexTrack AI, your privacy is our priority. This Privacy Policy explains how we collect, use, and protect your personal information when you use our products, services, and website.
      </p>

      <h3>1. Information We Collect</h3>
      <ul>
        <li>Name, email address, and phone number</li>
        <li>OAuth credentials to access services you authorize (e.g., Gmail)</li>
        <li>Usage data, device/browser info</li>
      </ul>

      <h3>2. How We Use Your Data</h3>
      <ul>
        <li>Provide and improve our services</li>
        <li>Personalize your experience</li>
        <li>Communicate updates and respond to inquiries</li>
        <li>Comply with legal obligations</li>
      </ul>

      <h3>3. Data Sharing and Disclosure of Google User Data</h3>
      <p>
        We do <strong>not</strong> sell your personal data. We only access and use your Google user data (such as Gmail metadata and content) to provide core functionality of LexTrack AI Mail features. We may share or disclose this data under the following limited circumstances:
      </p>
      <ul>
        <li><strong>With authorized third-party service providers</strong> who assist in hosting, processing, or analyzing the data solely to provide our services. These providers are contractually bound to comply with strict data privacy and security standards.</li>
        <li><strong>With your explicit consent</strong> for specific integrations or functionalities.</li>
        <li><strong>To comply with legal obligations</strong> or enforce our Terms of Service, such as responding to valid subpoenas, court orders, or regulatory inquiries.</li>
      </ul>
      <p>
        We never transfer, sell, or disclose your Google user data for marketing or advertising purposes. Your Google data is only used to deliver and improve application features.
      </p>

      <h3>4. Google Limited Use Compliance</h3>
      <p>
        LexTrack AI's application includes AI/ML model(s) that interact with user data obtained through Google Workspace APIs and/or Photos APIs. Our use of information received from these Google APIs adheres strictly to the <a href="https://developers.google.com/terms/api-services-user-data-policy#additional_requirements_for_specific_api_scopes" target="_blank" rel="noopener noreferrer">Google API Services User Data Policy</a>, including the Limited Use requirements. We affirmatively state our compliance with these Limited Use restrictions.
      </p>

      <h3>5. Security</h3>
      <p>We use encryption, access controls, and regular audits to protect your data.</p>

      <h3>6. Your Rights</h3>
      <ul>
        <li>Request access or deletion of your data</li>
        <li>Revoke OAuth permissions at any time</li>
        <li>Contact us at <a href="mailto:legal@lextrackai.com">legal@lextrackai.com</a></li>
      </ul>

      <h3>7. Children's Privacy</h3>
      <p>We do not knowingly collect data from children under 13.</p>

      <h3>8. Changes</h3>
      <p>This policy may update from time to time. The updated date will always reflect at the top.</p>

      <h3>9. Contact</h3>
      <p>Email us: <a href="mailto:legal@lextrackai.com">legal@lextrackai.com</a></p>
    </div>
  );
};

export default PrivacyPolicy;
